import React from 'react';
import { modelClass } from '/imports/api/assets';
import { ModelFormPage } from '/imports/ui/ModelFormPage';

export const AssetPage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [[{ field: 'botId', label: 'Bot ID' }], [{ field: 'bot', label: 'Bot' }], [{ field: 'cardId', label: 'Card ID' }], [{ field: 'card', label: 'Card' }], [{ field: 'typ', label: 'Type Code' }], [{ field: 'qty', label: 'Quantity' }], [{ field: 'tradeable', label: 'Tradeable' }]]}
  />
);
